export default "__VITE_ASSET__yNzplbts__"